export const TRADE_COLORS = {
  HVAC: {
    badge: 'text-lime border-lime/40',
    badgeLight: 'text-[#4d7c0f] bg-[#c6f24e]/30 border-[#a8cf3d]',
    goal: 'text-lime bg-lime/10 border-lime/30',
    goalLight: 'text-[#4d7c0f] bg-[#c6f24e]/25 border-[#a8cf3d]/70',
    hover: 'hover:border-lime/60',
    hoverLight: 'hover:border-[#a8cf3d]',
    text: 'text-lime',
    chip: 'bg-lime text-black border-lime',
    sidebar: 'bg-lime/10 text-lime',
  },
  Plumbing: {
    badge: 'text-[#3b9eff] border-[#3b9eff]/40',
    badgeLight: 'text-[#1668c7] bg-[#3b9eff]/15 border-[#3b9eff]/60',
    goal: 'text-[#3b9eff] bg-[#3b9eff]/10 border-[#3b9eff]/30',
    goalLight: 'text-[#1668c7] bg-[#3b9eff]/12 border-[#3b9eff]/50',
    hover: 'hover:border-[#3b9eff]/60',
    hoverLight: 'hover:border-[#3b9eff]',
    text: 'text-[#3b9eff]',
    chip: 'bg-[#3b9eff] text-black border-[#3b9eff]',
    sidebar: 'bg-[#3b9eff]/10 text-[#3b9eff]',
  },
  Electrical: {
    badge: 'text-[#ec6a1c] border-[#ec6a1c]/40',
    badgeLight: 'text-[#c2530e] bg-[#ec6a1c]/15 border-[#ec6a1c]/60',
    goal: 'text-[#ec6a1c] bg-[#ec6a1c]/10 border-[#ec6a1c]/30',
    goalLight: 'text-[#c2530e] bg-[#ec6a1c]/12 border-[#ec6a1c]/50',
    hover: 'hover:border-[#ec6a1c]/60',
    hoverLight: 'hover:border-[#ec6a1c]',
    text: 'text-[#ec6a1c]',
    chip: 'bg-[#ec6a1c] text-black border-[#ec6a1c]',
    sidebar: 'bg-[#ec6a1c]/10 text-[#ec6a1c]',
  },
};

export const tradeColor = (trade) =>
  TRADE_COLORS[trade] || {
    badge: 'text-gray border-divider',
    badgeLight: 'text-[#4a4f47] bg-black/5 border-[#d8dbd2]',
    goal: 'text-gray bg-black border-divider',
    goalLight: 'text-[#4a4f47] bg-black/5 border-[#d8dbd2]',
    hover: 'hover:border-lime/60',
    hoverLight: 'hover:border-[#a8cf3d]',
    text: 'text-gray',
    chip: 'bg-lime text-black border-lime',
    sidebar: 'bg-lime/10 text-lime',
  };
